import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"

export default class BasedIn extends Component {
  constructor(obj) {
    super(obj)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })
  }

  animate() {
    const title = qs(".title", this.el)
    const img = qs(".img-wrapper", this.el)
    const address = qsa(".address .char-1", this.el)
    const openingHours = qsa(".opening-hours .line-0", this.el)
    const tel = qsa(".tel .line-0", this.el)
    const mail = qsa(".mail .line-0", this.el)

    const lines = qsa(".address .line-0", this.el)
    lines.forEach(line => {
      line.style.overflow = "hidden"
    })

    gsap.from(title, {
      y: 100,
      autoAlpha: 0,
      duration: 1.2,
      scrollTrigger: {
        trigger: title,
        start: "top bottom",
      },
    })

    gsap.from(address, {
      y: "100%",
      stagger: 0.03,
      duration: 1.2,
      scrollTrigger: {
        trigger: address,
        start: "top bottom",
      },
    })

    gsap.from([openingHours, tel, mail], {
      y: "100%",
      autoAlpha: 0,
      stagger: 0.1,
      duration: 1.2,
      delay: 0.5,
      scrollTrigger: {
        trigger: openingHours,
        start: "top bottom",
      },
    })

    gsap.to(img, {
      width: "100%",
      duration: 1.2,
      scrollTrigger: {
        trigger: img,
        start: "top bottom",
      },
    })
  }
}
